module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAPhJREFUWAljYBgFIz0EGIkNAPsN2T/+///PzsbKrrzHp/8eNn0uWwqVfv3+eZeRkfHnwYCpHNjUoIsxoQvg4oMsB8n9+f+bDZcamBxMLS51yOIYIQD06SSgAldkRSA20FANqNg9oA9/octD1YAcpwRiA9XcANFoYDcwZPKQxViQOSA20KJcdDE0vhJQDZoQJhfJwciSIE+gOIDoKEA2hZrsUQcMeAhgJEJGBqZ0asbxoDcLoxyw25jdT0tXH/KfWohsPkYUMPz7X4CsgAZsFAcMeCIcdcBoCIyGwGgIjIYARggwMjLsoUH5DzaSkYFxN63MHjV36IYAAHvbPTn8KUKZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/日历@2x.png
// module id = Hr1m
// module chunks = 1